import React, { useState, useEffect, useRef, Children } from "react";
import AMapLoader from "@amap/amap-jsapi-loader";

type Props = {
  loading?: Element;
  children?: any;
  initMapOptions?: any;
  onInited?: (map) => void;
};

export default function AMap(props: Props) {
  const { initMapOptions = {}, onInited = () => {} } = props;
  const [loaded, setloaded] = useState(false);
  const [map, setMap] = useState(null);
  const mapWrapper = useRef(null);

  function renderChildren(currentMap: any) {
    return Children.map(props.children, (child) => {
      if (child) {
        const cType = child.type;
        /* 针对下面两种组件不注入地图相关属性
         * 1. 明确声明不需要注入的
         * 2. DOM 元素
         */
        if (cType.preventAmap || typeof cType === "string") {
          return child;
        }
        return React.cloneElement(child, {
          __map__: currentMap,
        });
      }
      return child;
    });
  }

  useEffect(() => {
    // 返回当前页面的环境，依赖于当前域名
    AMapLoader.load({
      key: "e9c4e1537725c67ae982d59e02c6eca4",
      version: "1.4.15",
      plugins: ['AMap.Geolocation', 'AMap.Geocoder'],
    })
      .then((AMap) => {
        const amapTarget = new AMap.Map(mapWrapper.current, initMapOptions ? initMapOptions : {})
        setMap(amapTarget);
        setloaded(true);
        if (onInited) {
          onInited(amapTarget);
        }
      })
      .catch((e) => {
        console.log('高德地图加载失败', e, initMapOptions);
        throw new Error(`高德地图加载失败：${e.message}`);
      });
  }, []);

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <div ref={mapWrapper} style={{ width: "100%", height: "100%" }}>
        {loaded ? null : props.loading || null}
      </div>
      {map ? renderChildren(map) : null}
    </div>
  );
}
